module.exports = __webpack_public_path__ + "img/Logo.d33fc617.png";